module.exports = __webpack_public_path__ + "media/LACHSONG.e0a1146f.mp3";